import HomeLayout from './home-layout';

export default HomeLayout;
